// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sk3 svg {
  font: 10px sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.sk3 text {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.sk3-label {
  font-size: 14px;
  fill: grey;
  stroke-width: 2;
}
.sk3-axis path,
.sk3-axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
}
.sk3-axis line.sk3-grid {
  stroke: black;
  shape-rendering: crispEdges;
  stroke-opacity: .2;
  stroke-dasharray: 2;
}
path.sk3-line {
  stroke-width: 1;
  fill: none;
}
path.sk3-area {
  stroke-width: 0;
  opacity: 0.4;
}
.sk3-region {
  opacity: 0.1;
}`, "",{"version":3,"sources":["webpack://./src/legacy/lib/sk3/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":[".sk3 svg {\n  font: 10px sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.sk3 text {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n.sk3-label {\n  font-size: 14px;\n  fill: grey;\n  stroke-width: 2;\n}\n.sk3-axis path,\n.sk3-axis line {\n  fill: none;\n  stroke: #000;\n  shape-rendering: crispEdges;\n}\n.sk3-axis line.sk3-grid {\n  stroke: black;\n  shape-rendering: crispEdges;\n  stroke-opacity: .2;\n  stroke-dasharray: 2;\n}\npath.sk3-line {\n  stroke-width: 1;\n  fill: none;\n}\npath.sk3-area {\n  stroke-width: 0;\n  opacity: 0.4;\n}\n.sk3-region {\n  opacity: 0.1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
